import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankStatementImportRow  {
    _originalTypeClassName = "zERP.BO.BankStatementImportRow";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankStatementImportRow.translate = translateService;
}
this.Section = new Domain.BankStatementImportSection();
this.Id = null;
this.Date = null;
this.Amount = null;
this.AbsoluteAmount = null;
this.Code = null;
this.CodeMessage = null;
this.Reason = null;
this.CheckNumber = null;
this.RF = null;
this.HasInvoiceRule = false;
this.HasCheckRule = false;
this.RequiresInvoiceMatching = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
Amount:any;
AbsoluteAmount:any;
Code:any;
CodeMessage:any;
Reason:any;
CheckNumber:any;
RF:any;
HasInvoiceRule:any;
HasCheckRule:any;
RequiresInvoiceMatching:any;
Section:any;
MoneyTransaction:any;
Invoice:any;
Check:any;
static setSection = ($this, value) => {
var oldValue = $this.Section;
$this.Section = value;
if (value != null) {
if (oldValue != null) {
Domain.BankStatementImportSection.removeRows(oldValue, $this);
}
Domain.BankStatementImportSection.addRows(value, $this);
}
}
static setMoneyTransaction = ($this, value) => {
var oldValue = $this.MoneyTransaction;
$this.MoneyTransaction = value;
if (value != null) {
}
}
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setCheck = ($this, value) => {
var oldValue = $this.Check;
$this.Check = value;
if (value != null) {
}
}

static GetAbsoluteAmount($this: any): any{return Math.abs($this?.Amount);
}
static GetClassName(): any{return "BankStatementImportRow";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}